export default __webpack_public_path__ + "static/media/floristPreview.342d6fca.webp";